import type { Hover, ToolId } from './tools/tool';

const RESIZE: Record<string, string> = { n: 'ns-resize', s: 'ns-resize', e: 'ew-resize', w: 'ew-resize', ne: 'nesw-resize', sw: 'nesw-resize', nw: 'nwse-resize', se: 'nwse-resize' };

/** The canvas cursor for the current tool and what the pointer rests on (handle cursors ignore the object's rotation). */
export function cursorFor(s: { tool: ToolId; hover: Hover; selected: boolean; dragging: boolean; readOnly: boolean }): string {
  if (s.tool === 'hand') return s.dragging ? 'grabbing' : 'grab';
  if (s.readOnly) return 'default';
  if (s.tool !== 'select') return s.tool === 'image' ? 'default' : s.tool === 'text' ? 'text' : 'crosshair';
  const h = s.hover;
  if (h.handle) return h.handle === 'rotate' ? 'grab' : RESIZE[h.handle]!;
  if (h.dot) return 'crosshair';
  if (h.plus) return 'pointer';
  return h.id && (s.selected || h.grab) ? 'move' : 'default';
}
